import React, { useState } from 'react';

import InlineText from './InlineText';

type EditableTextProps = { value: string; label: string; enabled: boolean; multiline?: boolean; placeholder?: string; onCommit: (value: string) => void; children: React.ReactNode };

export default function EditableText({ value, label, enabled, multiline, placeholder, onCommit, children }: EditableTextProps) {
  const [editing, setEditing] = useState(false);
  if (!enabled) return <>{children}</>;
  if (editing)
    return (
      <InlineText
        label={label}
        multiline={multiline}
        onCancel={() => setEditing(false)}
        onCommit={(next) => {
          setEditing(false);
          if (next !== value) onCommit(next);
        }}
        placeholder={placeholder}
        value={value}
      />
    );
  return (
    <span
      aria-label={`Edit ${label.toLowerCase()}`}
      className={value ? 'editable' : 'editable empty'}
      onClick={(event) => {
        event.stopPropagation();
        setEditing(true);
      }}
      onKeyDown={(event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          setEditing(true);
        }
      }}
      role="button"
      tabIndex={0}
    >
      {value ? children : placeholder}
    </span>
  );
}
